import ComingSoon from "@/pages/ComingSoon";

export default function Nft() {
  return (
    <ComingSoon
      testId="nft-page"
      chapter="Archive · Artifacts"
      title="Artifacts"
      blurb="Pieces of the archive, minted. Artwork and unreleased stems for the ones who were paying attention."
    />
  );
}
